<div class="cipo--height--full">
    <div [id]="mapId()" class="cipo--width--full cipo--height--full cipo--overflow--hidden"></div>
    <div id="mapControls" class="cipo--display--none">
        @if (multiple()) {
            <button mat-mini-fab color="primary" class="azure-map-control" [attr.aria-label]="'a11y.map.fitToAllMarkers' | translate" (click)="fitMapToAllMarkers()">
                <mat-icon aria-hidden="true">filter_center_focus</mat-icon>
            </button>
        }
        <button mat-mini-fab color="primary" class="azure-map-control" [attr.aria-label]="'a11y.map.currentLocation' | translate" (click)="setMapToCurrentLocation()">
            <mat-icon aria-hidden="true">my_location</mat-icon>
        </button>
    </div>
</div>
